import { SelectCards } from 'components/Form/SelectCards';
import React from 'react';
import 'twin.macro';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import { UserIntent } from 'containers/Demarrage/types';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { useDemarrage } from 'containers/Demarrage/queries/useDemarrage';
import { useTranslation } from 'react-i18next';

export function Objectifs() {
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding']);
  const objectifs: Array<{
    label: string;
    value: UserIntent;
  }> = [
    {
      label: t('onboarding:goals.edt'),
      value: 'emploi du temps',
    },
    {
      label: t('onboarding:goals.cj'),
      value: 'cahier journal',
    },
    {
      label: t('onboarding:goals.sequence'),
      value: 'sequence',
    },
    {
      label: t('onboarding:goals.programmation'),
      value: 'programmation',
    },
    {
      label: t('onboarding:goals.appelClasse'),
      value: "registre d'appel",
    },
    {
      label: t('onboarding:goals.evaluationsAndLSU'),
      value: 'carnet de notes',
    },
    {
      label: t('onboarding:goals.other'),
      value: 'autre',
    },
  ];

  const { data: demarrageData } = useDemarrage();
  if (!demarrageData) {
    return null;
  }
  return (
    <StepWrapper
      title={t('onboarding:goals.title')}
      nextLabel={t('onboarding:goals.confirm')}
      currentStep="objectifs"
    >
      <SelectCards<UserIntent, true>
        options={objectifs}
        value={demarrageData?.userIntents || []}
        onChange={async userIntents => {
          await update({ userIntents });
        }}
        size="big"
        isMulti
        direction="vertical"
      />
    </StepWrapper>
  );
}
